import http from 'utils/http';

export const fetchExpediteDeliveriesReport = ({ query, page }) =>
  http
    .get(
      `v1/organizations/{{organizationId}}/reporting/expedite-deliveries/?page=${page}&${query}`,
    )
    .then((res) => res.data);
